import { render, staticRenderFns } from "./SummaryPrice.vue?vue&type=template&id=57652a80&"
import script from "./SummaryPrice.vue?vue&type=script&lang=js&"
export * from "./SummaryPrice.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports